<template>
  <div>(TODO) key or value</div>
</template>

<script>
import { isObject } from 'lodash';
import { abstractField } from "vue-form-generator";
export default {
  mixins: [ abstractField ],
  data() {
    if (!isObject(this.value)) {
      this.$set(this, 'value', {key:'',value:''});
    }
    return {
    }
  },
  components:{
  },
  methods: {
  },
  computed:{
  },
}
</script>

